/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BoardManagementSummary,
  BoardPmSummary,
  GetBoardManagementSummaryParams,
  GetBoardPmSummaryParams
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary Operativni Board pogled (BD-01) — aktivni ugovori/radni paketi, realizacija, tjedni izvještaji
 */
export const getBoardPmSummary = (
    params?: GetBoardPmSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<BoardPmSummary>(
      {url: `/api/v1/board/pm`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetBoardPmSummaryQueryKey = (params?: GetBoardPmSummaryParams,) => {
    return [
    `/api/v1/board/pm`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBoardPmSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getBoardPmSummary>>, TError = unknown>(params?: GetBoardPmSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardPmSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBoardPmSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBoardPmSummary>>> = ({ signal }) => getBoardPmSummary(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBoardPmSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBoardPmSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getBoardPmSummary>>>
export type GetBoardPmSummaryQueryError = unknown


export function useGetBoardPmSummary<TData = Awaited<ReturnType<typeof getBoardPmSummary>>, TError = unknown>(
 params: undefined |  GetBoardPmSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardPmSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoardPmSummary>>,
          TError,
          Awaited<ReturnType<typeof getBoardPmSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBoardPmSummary<TData = Awaited<ReturnType<typeof getBoardPmSummary>>, TError = unknown>(
 params?: GetBoardPmSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardPmSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoardPmSummary>>,
          TError,
          Awaited<ReturnType<typeof getBoardPmSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBoardPmSummary<TData = Awaited<ReturnType<typeof getBoardPmSummary>>, TError = unknown>(
 params?: GetBoardPmSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardPmSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Operativni Board pogled (BD-01) — aktivni ugovori/radni paketi, realizacija, tjedni izvještaji
 */

export function useGetBoardPmSummary<TData = Awaited<ReturnType<typeof getBoardPmSummary>>, TError = unknown>(
 params?: GetBoardPmSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardPmSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBoardPmSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Izvršni/financijski Board pogled (BD-02) — fakturiranje, naplata, ključna upozorenja
 */
export const getBoardManagementSummary = (
    params?: GetBoardManagementSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<BoardManagementSummary>(
      {url: `/api/v1/board/management`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetBoardManagementSummaryQueryKey = (params?: GetBoardManagementSummaryParams,) => {
    return [
    `/api/v1/board/management`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBoardManagementSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getBoardManagementSummary>>, TError = unknown>(params?: GetBoardManagementSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardManagementSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBoardManagementSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBoardManagementSummary>>> = ({ signal }) => getBoardManagementSummary(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBoardManagementSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBoardManagementSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getBoardManagementSummary>>>
export type GetBoardManagementSummaryQueryError = unknown


export function useGetBoardManagementSummary<TData = Awaited<ReturnType<typeof getBoardManagementSummary>>, TError = unknown>(
 params: undefined |  GetBoardManagementSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardManagementSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoardManagementSummary>>,
          TError,
          Awaited<ReturnType<typeof getBoardManagementSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBoardManagementSummary<TData = Awaited<ReturnType<typeof getBoardManagementSummary>>, TError = unknown>(
 params?: GetBoardManagementSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardManagementSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoardManagementSummary>>,
          TError,
          Awaited<ReturnType<typeof getBoardManagementSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBoardManagementSummary<TData = Awaited<ReturnType<typeof getBoardManagementSummary>>, TError = unknown>(
 params?: GetBoardManagementSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardManagementSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Izvršni/financijski Board pogled (BD-02) — fakturiranje, naplata, ključna upozorenja
 */

export function useGetBoardManagementSummary<TData = Awaited<ReturnType<typeof getBoardManagementSummary>>, TError = unknown>(
 params?: GetBoardManagementSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBoardManagementSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBoardManagementSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




